import { useEffect, useState } from 'react';

import PageBanner from '../../shared/components/pageBanner/pageBanner';
import './contact.css';
import { Form, FormGroup, FormFeedback, Input, Label } from "reactstrap";
import Regex from "../../utilities/regex";
import axios from 'axios';
import SyncLoader from "react-spinners/SyncLoader";
import { css } from "@emotion/react";
import { toast } from "react-toastify";
import DateFnsUtils from '@date-io/date-fns';
import { DateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";


const Contact = () => {

	const [info, setInfo] = useState();
	const [firstName, setFirstName] = useState("");
	const [lastName, setLastName] = useState("");
	const [email, setEmail] = useState("");
	const [phone, setPhone] = useState("");
	const [prefTime, setPrefTime] = useState(null);
	const [message, setMessage] = useState("");
	const [errors, setErrors] = useState();
	const [loading, setLoading] = useState();
	const [disable, setDisable] = useState()
	const [color, setColor] = useState("#ffffff");
	const [validate, setValidate] = useState();

	const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
  `;


	useEffect(() => {
		window.scrollTo(0, 0);
		fetchData();
	}, [])

	useEffect(() => {
		if (validate) {
			console.log("errors after validation", errors);
			const fst = errors.firstName;
			const lst = errors.lastName;
			const em = errors.email;
			const msg = errors.message;

			if (!fst && !lst && !em && !msg) {
				if (!prefTime) {
					toast.error("Please pick a preferred date and time");
					callback();
				}
				else {
					sendEmail({
						firstName,
						lastName,
						email,
						phone,
						prefTime,
						message
					});
					setFirstName("");
					setLastName("");
					setEmail("");
					setPhone("");
					setPrefTime(null);
					setMessage("");
				}
			}
			else {
				toast.error("Error!!! invalid values entered");
				callback();
			}
		}
	}, [validate])

	const fetchData = async () => {
		const response = await axios.request({
			method: 'get',
			url: `${process.env.REACT_APP_SERVER_URL}/v1/cms/get-contact-us-info`
		})
		setInfo(response.data[0]);
	}

	const sendEmail = async (data) => {
		const response = await axios.request({
			data,
			method: 'post',
			url: `${process.env.REACT_APP_SERVER_URL}/v1/cms/contact-us`
		})
		if (response.data.success)
			toast.success("Your Query has been submitted successfully");
		else {
			toast.error("Error while sending email");
		}
		callback();
	}

	const callback = () => {
		setLoading(false);
		setDisable(false);
		setValidate(false);
	}

	const handleSubmit = (e) => {
		e.preventDefault();
		setLoading(true)
		setDisable(true);
		let obj = { firstName: false, lastName: false, email: false, message: false };

		if (!Regex.string(firstName)) {
			obj = { ...obj, firstName: true };
		}

		if (!Regex.string(lastName)) {
			obj = { ...obj, lastName: true };
		}

		if (!Regex.email(email)) {
			obj = { ...obj, email: true };
		}

		if (message.trim().length < 10) {
			obj = { ...obj, message: true };
		}

		setErrors(obj);
		setValidate(true);
	}

	return (
		<div className="wrapper">
			<PageBanner check={false} title="Contact Us" content={info && info.subtitle} />
			<div className="contact-form-block">
				<div className="container">
					<Form className="contact-form bg-white position-relative p-3" onSubmit={handleSubmit}>
						<div className="row">
							<div className="col-md-6">
								<FormGroup className="form-group">
									<Label for="first-name" className="form-label text-uppercase">First Name</Label>
									<Input id="first-name" name="first-name" className="form-control" type="text" placeholder="Type here..." required onChange={(e) => setFirstName(e.target.value)} value={firstName} invalid={firstName && !Regex.string(firstName)} />
									<FormFeedback id="first-name-error">
										Please enter a valid first name.
									</FormFeedback>
								</FormGroup>
							</div>
							<div className="col-md-6">
								<FormGroup className="form-group">
									<Label for="last-name" className="form-label text-uppercase">Last Name</Label>
									<Input id="last-name" name="last-name" className="form-control" type="text" placeholder="Type here..." required onChange={(e) => setLastName(e.target.value)} value={lastName} invalid={lastName && !Regex.string(lastName)} />
									<FormFeedback id="last-name-error">
										Please enter a valid last name.
									</FormFeedback>
								</FormGroup>
							</div>
							<div className="col-md-6">
								<FormGroup className="form-group">
									<Label for="email" className="form-label text-uppercase">Email</Label>
									<Input id="email" name="email" className="form-control" type="email" placeholder="Type here..." required onChange={(e) => setEmail(e.target.value)} value={email} invalid={email && !Regex.email(email)} />
									<FormFeedback id="email-error">
										Please enter a valid email address.
									</FormFeedback>
								</FormGroup>
							</div>
							<div className="col-md-6">
								<FormGroup className="form-group">
									<Label for="phone" className="form-label text-uppercase">Phone</Label>
									<Input id="phone" name="phone" className="form-control" type="tel" placeholder="123-45-678" required onChange={(e) => setPhone(e.target.value)} value={phone} pattern={"[0-9]{3}-[0-9]{2}-[0-9]{3}"} />
									<small className="form-label">Format: 123-45-678</small>
								</FormGroup>
							</div>
							<div className="col-md-12">
								<FormGroup className="form-group">
									{/* <Label for="pref-time" className="form-label text-uppercase">Select Preferred Time</Label>
									<Input id="pref-time" name="pref-time" className="form-control" placeholder="Type here..." required onChange={(e) => setPrefTime(e.target.value)} value={prefTime} invalid={prefTime && !Regex.string(prefTime)} />
									<FormFeedback id="pref-time-error">
									</FormFeedback> */}
									<MuiPickersUtilsProvider utils={DateFnsUtils}>
										<Label for="pref-time" className="form-label text-uppercase">Select Preferred Time</Label>
										<DateTimePicker
											id="pref-time"
											className="form-control"
											placeholder="Type here..."
											value={prefTime}
											onChange={(data) => setPrefTime(data)}
										/>
									</MuiPickersUtilsProvider>
								</FormGroup>
							</div>
							<div className="col-md-12">
								<FormGroup className="form-group">
									<Label for="message" className="form-label text-uppercase">Message</Label>
									<Input id="message" name="message" type="textarea" className="form-control" rows="5" cols="5" required placeholder="Type Here..." onChange={(e) => setMessage(e.target.value)} value={message} invalid={message && message.trim().length < 10} />
									<FormFeedback id="message-error">
										Message should be minimum 10 characters long.
									</FormFeedback>
								</FormGroup>
							</div>
							<div className="col-md-12">
								<FormGroup className="form-group">
									<button type="submit" className="btn btn-theme btn-large btn-custom" disable={disable} >
										{loading && <SyncLoader color={color} loading={loading} css={override} size={11} />}
										{!loading && "Send Message"}
									</button>
								</FormGroup>
							</div>
						</div>
					</Form>
				</div>
			</div>
		</div>
	)
}

export default Contact
